import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { useHistory } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';


const useStyles = makeStyles((theme) => ({
    root: {
        position: `absolute`,
        left: 0,
        bottom: '20px',
        marginLeft: '6px'
      },
      iconColor: { 
          color: '#fff' 
      },
  }));

function LogoutButton(props) {
    const classes = useStyles(); 

    const history = useHistory();
    const { oktaAuth, authState } = useOktaAuth();

    if (authState.isPending) return null;

    const logout = async () => oktaAuth.signOut();


    return(
        <div className={ classes.root }>
            {
                authState.isAuthenticated ? 
                <Tooltip title="Logout">
                    <Button onClick={logout}>
                        <ExitToAppIcon className={ classes.iconColor } />
                    </Button>
                </Tooltip> : <div></div>
            }
        </div>
    )
}
  
  export default LogoutButton;

